export default __webpack_public_path__ + "9f29359e9f9e550bcf5ee230504e17dc.svg";